// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationDE from './locales/de/translation.json';

const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDE,
  },
};

i18n
  .use(LanguageDetector) // Detects user's language
  .use(initReactI18next) // Passes i18n to react-i18next
  .init({
    resources,
    fallbackLng: 'de', //dafault fallback language
    debug: false, // Disable debug for production
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      // Add more specific detection options
      convertDetectedLanguage: (lng) => {
        // Convert detected language to our supported languages
        if (lng.startsWith('de')) return 'de';
        if (lng.startsWith('en')) return 'en';
        return 'de'; // fallback
      }
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
